app.service('countdownTimer', (broker) => {
	class CountdownTimer {
		constructor(elementSelector, options = {}) { // options: { onEnd: function }
			this.$element = $(elementSelector);
			this.$counter = this.$element.find('.counter-content');
			this.countDownDate = new Date(this.$element.data('end')).getTime();

			this.options = {
				onEnd: options.onEnd || (() => {}),
			};

			this.timer = null;
			this.currentDateTime = null;
			this.init();
		}

		init() {
			this.setEvents();

			if (!this.currentDateTime) {
				this.$counter.text("Wczytywanie...");
			}
		}

		startTimer() {
			this.renderCounter();
			this.timer = setInterval(() => this.renderCounter(), 1000);
		}

		renderCounter() {
			const currentTime = this.currentDateTime.getTime();
			const distance = this.countDownDate - currentTime;

			if (distance < 0) {
				this.stop();
				this.options.onEnd(); // Trigger the onEnd callback
				return;
			}

			const counter = this.getCounter(distance);
			this.render(counter);
			this.currentDateTime.setSeconds(this.currentDateTime.getSeconds() + 1);
		}

		getCounter(distance) {
			const days = Math.floor(distance / (1000 * 60 * 60 * 24));
			const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distance % (1000 * 60)) / 1000);

			return {days, hours, minutes, seconds};
		}

		render(counter) {

			this.$counter.html(`
				<div class="count-item">
					<span class="count">${this.formattedNumber(counter.days)}</span>
					<span class="label">${+counter.days === 1 ? 'dzień' : 'dni'}</span>
				</div>
				<div class="sep"></div>
				<div class="count-item">
					<span class="count">${this.formattedNumber(counter.hours)}</span>
					<span class="label">godz.</span>
				</div>
				<div class="sep"></div>
				<div class="count-item">
					<span class="count">${this.formattedNumber(counter.minutes)}</span>
					<span class="label">min.</span>
				</div>
				<div class="sep"></div>
				<div class="count-item">
					<span class="count">${this.formattedNumber(counter.seconds)}</span>
					<span class="label">sek.</span>
				</div>
		`);
		}

		formattedNumber(num) {
			return this.padLeft(String(num))
				.split("")
				.map(digit => `<span class="number">${digit}</span>`)
				.join("");
		}

		padLeft(digit) {
			if (digit.length < 2) {
				return `0${digit}`;
			}

			return digit;
		}

		setEvents() {
			broker.on('DATETIME_ONLOAD', (e, date) => {
				this.currentDateTime = new Date(date);
				this.startTimer();
			});
		}

		stop() {
			clearInterval(this.timer);
		}
	}

	return {
		create(elementSelector, options) {
			return new CountdownTimer(elementSelector, options);
		}
	};
});